import React from 'react'
import i18next from "i18next";
import {Form, Request} from 'kaiju.core'
import {Divider, Modal, notification} from 'antd';
import i18n from "i18next";
import {useParams} from "react-router-dom";
import {boolean} from "yup";


export const SingleCreate: React.FC<{ open: boolean, onClose: any, onCreate: Function }> = ({open, onClose, onCreate}) => {
    const {appId} = useParams();

    const [api, contextHolder] = notification.useNotification();
    const FormConf = {
        fields: [{
            id: "create",
            fields: [
                {
                    id: "id",
                    kind: "string",
                    required: true,
                    max: 36,
                    label: i18n.t("common.id")
                },
                {
                    id: "label",
                    kind: "string",
                    required: true,
                    max: 36,
                    label: i18n.t("common.label")
                },
                {
                    id: "has_draft",
                    kind: "boolean",
                    label: i18n.t("single.has_draft")
                }
            ]
        }],
        disableGroups: true,
        onSubmit: (values: any, formikState: any) => {
            Request('ContentTypeBuilder.single.create', {
                ...values,
                application: appId,
            }).then((data: any) => {
                const error = data.error;
                if (error) {
                    const code = error.code;
                    const message = i18n.t("single.error.duplicate");
                    if (code === 409) {
                        formikState.setFieldError("id", message)
                        api.error({
                            message: message,
                            placement: 'topRight',
                            duration: 2
                        })
                    }
                } else {
                    onCreate(data)
                    close()
                }
            })
        }
    };

    const formStore = Form.useFormStore(FormConf)
    const close = () => {
        onClose()
        formStore.reset({})
    }

    return (
        <>
            {contextHolder}
            <Modal title={i18next.t("single.create-new")} open={open} onOk={formStore.submit} onCancel={close}
                   okText={i18next.t("common.create")} cancelText={i18next.t("common.cancel")}>
                <Divider/>
                <Form store={formStore} key={"content-create"}/>
            </Modal>
        </>
    )
}
